// extracted by mini-css-extract-plugin
export default {"overlay":"cx-z","bodyOpen":"dx-z","content":"ex-z","header":"fx-z","close":"gx-z","closeNoHeading":"hx-z"};